import Vue from 'vue'
import Vuex from 'vuex';
import _ from 'lodash';
import { maxStampSize, stampPadding, ttsFontSizes } from './storeUtils';
import actions from "./actions";
import mutations from './mutations';
import modules from './modules'
import getters from './getters'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isFisher: false,
    fisherInfo: null,
    trackId: '',
    currentFigure: null,
    currentFigureId: null, // 数字人ID
    currentFigureSrc: '',
    id: null,
    draftId: null,
    templateId: null,
    currentIcon: 'snippet',
    currentMenu: 'VideoClipList',
    currentSubmenu: 'VideoFormat',
    stampType: 'imageStamp',
    stampEnabled: false,
    stamp: {
      url: '',
      opacity: 60,
      position: 'leftTop',
      size: 100,
      aspectRatio: 1,
      type: '',
      offset: 15
    },
    token: '',
    activeFragmentIndex: 0,
    activeTransitionIndex: 0, // 当前选中的转场索引
    playing: false,
    currentProgress: 0,
    effects: {},
    fragments: [
      {
        duration: 3000,
        effects: [],
        id: "frag" + (+new Date()),
        name: "frag1",
        start: 0,
        background: null,
        transition: null,
        backgroundColor: '#fff',
        hideStamp: false,
        audios: []
      },
    ],
    musicList: [],
    materialList: [],
    currentMusic: {},
    myVideoMusic: {}, // 视频使用的背景音乐
    musicStartEnd: [0, 300],
    myVideoMusicStartEnd: [0, 300], //视频使用的背景音乐 开始与结束时间
    setupMusic: false,
    videoStartEnd: [0, 300],
    musicVolume: 1,
    myMusicVolume: 1,
    musicFade: {
      fadeIn: false,
      fadeInDuration: 1e3,
      fadeOut: true,
      fadeOutDuration: 2e3,
      loop: true,
      delay: 0
    },
    selectedEffectIds: [],
    hoveringEffectId: null,
    effectEditing: null,
    effectDragging: false,
    effectReordering: false,
    nextEffectOrder: null,
    timelineHeight: 200,
    previewVisible: false,
    editStatus: false,
    screenRatio: 16 / 9, // 视频宽高比例
    previewScreenHeight: 480, // 预览时，默认的屏幕高度
    screenHeight: 720, // 真实的屏幕高度
    showTransitionList: false,
    showSubVideoClipList: false,
    videoName: '',
    ttsRule: {
      style: 0,
      align: 'center',
      position: 0,
      color: '#fff',
      fontSize: 'small',
      opacity: 100,
      useBackground: true,
      backgroundColor: '#333',
      backgroundOpacity: 100,
      fontFamily: 'SourceHanSansCN-Regular',
      musicVolume: 100,
      volume: 100,
      remark: true,
      strokeColor: '#EE44CC',
      strokeWidth: 0,
      useShadow: false,
      shadow: 1,
      shadowColor: '#000',
      marginV: 36
    },
    selectedTrackId: null,
    trackEditing: false,
    previewSettingsOpen: false,
    translationEnabled: false,
    languageLookup: {},
    selectedLanguages: [],
    languageSex: 'FEMALE', // FEMALE女性  MALE男性
    languageLoaded: false,
    ttsEnabled: true,
    useTTSLanguages: true,
    useCustomTTS: false,
    customTTS: {},
    customTTSIds: [],
    previewLanguage: '',
    languageOptions: {},
    loading: true,
    translationLookup: {},
    fontList: [],
    musicMenuIsPlaying: false,
    musicInfoIsPlaying: false,
    seoTitleList: [],
    seoTitleListKeyData: [],
    templateList: [],
    previewTemplate: null,
    fragmentReordering: false,
    nextFragmentOrder: null,
    contextMenu: {
      visible: false,
      x: 0,
      y: 0,
      items: []
    },
    clipboard: null,
    clipboardType: 'copy',
    videoTemplateList: [],
    templateSceneList: [{ value: 0, name: 'All Scenes' }],
    templateIndustryList: [{ value: 0, name: 'All Industries' }],
    templateStyleList: [{ value: 0, name: 'All Style' }],
    templateMediaList: [{ value: 0, name: 'All Media' }],
    fragmentTypeList: [],
    backUrl: '/lists',
    templatePlayerVisible: false,
    templatePlayerData: {
      fragments: [],
      effects: {},
      stamp: null,
      screenHeight: 720
    },
    currentPresetTemplate: null,
    editingContainer: null,
    presets: [],
    presetsCats: [],
    undoStack: [],
    undoPos: -1,
    recordDisabled: false,
    liFisherSites: [],
    playerScale: 100,
    renameVisible: false,
    renameId: null,
    posterVisible: false,
    posterTitle: {},
    posterMetadata: {
      current: 0,
      url: ''
    },
    thumbnail: '', //封面地址
    ms_cover: 0, //封面图截取第几毫秒作为封面图
    filterShowing: false,
    prevGradients: {},
    timelineFilter: 'unlocked',
    videoSeriesTagMode: false,
    gridShowing: false,
    shapeNames: {},
    shapeMetadata: {},
    shapes: [],
    containers: [],
    transitionNames: {},
    transitions: [],
    effectNames: {},
    generalEffects: [],
    textEffects: [],
    showMealDialog: false,
    keyboardShortcutShowing: false,
    isDark: false,
    audios: {},
    selectedAudioId: null,
    audioEditing: false,
    uploadModalShowing: false,
    uploadModalType: 0, // 1 image 2 video 4 audio
    uploadModalMarker: 0,
    uploading: false,
    uploadDone: false,
    uploadSpace: { max_size: 1073741824, unused_size: 1073741824, used_size: 0 },
    uploadTotalSize: 0,
    uploadFinishSize: 0,
    uploadList: [],
    subtitleTracks: {},
    subtitleAudios: {},
    savePresetShowing: false,
    savePresetType: 'preset', // "preset" | "combination"
    userMeal: null,
    userBasics: null,
    translationLocked: false,
    translationGenerated: false,
    linkMaterialVisible: false,
    videoSeriesTagVisible: false,
    textVideoSeriesTagVisible: false,
    fontNameLookup: {},
    fontStates: {},
    videoSeriesTagData: {
      1: {},
      2: {}
    },
    videoSeriesTagNames: {},
    coverParams: [],
    coverWatermark: false,
    myMateriaChecked: false, // 是否多选我的素材
    myMateriaCheckedList: [], // 当前我的素材多选列表
    videoScripts: [],
    usedVideoScriptId: null,
    videoScriptTypes: [],
    videoScriptScenes: [],
    videoScriptPeekerVisible: false,
    videoScriptPreviewerVisible: false,
    videoScriptPreviewerList: [],
    menuCollapsed: false,
    initialized: false,
    materialColorVisible: false,
    materialColor: '',
    usedTemplateId: null,
    alternateTemplates: {},
    musicCategoryList: [],
    selectionDrawing: false,
    preselectedEffectIds: [],
    selectionArea: {
      x: 0,
      y: 0,
      w: 0,
      h: 0
    },
    clipping: false,
    clippingEffect: null,
    readonly: false,
    snapEnabled: true,
    descKeywords: {
      keywords: '',
      desc: ''
    },
  },
  mutations,
  actions,
  getters: {
    figureEffect: state => {
      const figureEffect = _.find(state.effects, item => {
        return !!item.figure;
      });
      return figureEffect || null;
    },
    activeFragment(state) {
      return state.fragments[state.activeFragmentIndex] || { effects: [] };
    },
    activeTransitionFragment(state) {
      return state.fragments[state.activeTransitionIndex] || { effects: [] };
    },
    selectedEffectId(state) {
      if (state.selectedEffectIds.length === 1) {
        return state.selectedEffectIds[0];
      }
      return null;
    },
    selectedEffect(state, getters) {
      if (getters.selectedEffectId === 'BACKGROUND_SELECT') {
        return state.effects[getters.activeFragment.background] || null;
      }
      return state.effects[getters.selectedEffectId] || null;
    },
    currentEffect(_, getters) {
      return getters.selectedEffect || {};
    },
    effectInfo(_, getters) {
      const currentEffect = getters.currentEffect;
      const { rotate, src, brightness, opacity, scale, top, left, width, height } = currentEffect.content ? currentEffect.content : {};
      const { start, duration } = currentEffect;
      return { rotate, start, duration, src, brightness, opacity, scale, top, left, width, height }
    },
    showSubmenu(state) {
      return state.showTransitionList || state.showSubVideoClipList
    },
    // 视频的缩放比例
    aspectRatio(state) {
      return state.screenHeight / state.previewScreenHeight
    },
    maxStampSize,
    ttsFontSizes,
    ttsMaxLength(state) {
      if (state.screenRatio > 1) {
        return { large: 100, small: 100 };
      }
      if (state.screenRatio === 1) {
        return { large: 75, small: 75 };
      }
      return { large: 50, small: 60 };
    },
    selectedLanguageOptions(state) {
      const { languageLookup, selectedLanguages } = state;
      return [].concat(selectedLanguages).map(k => ({
        text: languageLookup[k] && languageLookup[k].name,
        value: k
      }));
    },
    seoList(state) {
      const { seoTitleList, seoTitleListKeyData } = state;
      return seoTitleList.map((item, index) => ({ title: item, ...seoTitleListKeyData[index] })).sort((a, b) => b.vol - a.vol)
    },
    revealMask(state) {
      return state.editStatus
        || (state.currentSubmenu === 'ImageStampInfo' && state.currentMenu === 'MaterialMenu')
        || state.editingContainer
        || state.audioEditing;
    },
    totalDuration(state) {
      return Math.max.apply(Math, state.fragments.map(frag => frag.start + frag.duration));
    },
    reverseLanguageLookup(state) {
      const { languageLookup } = state;

      const ret = {};
      Object.keys(languageLookup).forEach(k => {
        ret[languageLookup[k].subtitle] = k;
      });
      return ret;
    },
    subtitleItemList(state) {
      const { subtitleTracks } = state;
      return Object.keys(subtitleTracks)
        .map(k => subtitleTracks[k])
        .sort((x, y) => {
          return x.start - y.start;
        }); // TODO:
    },
    intersectingTracks(_, getters) {
      const ret = {};
      getters.subtitleItemList.forEach((item, i) => {
        if (i > 0) {
          const prev = getters.subtitleItemList[i - 1];
          if (item.start < prev.start + prev.duration) {
            ret[item.id] = true;
            return;
          }
        }
        if (item.start + item.duration > getters.totalDuration) {
          ret[item.id] = true;
        }
      });
      return ret;
    },
    translated(state) {
      const { translationLocked, previewLanguage } = state;
      return previewLanguage && !translationLocked;
    },
    customTTSList(state) {
      return state.customTTSIds.map(id => state.customTTS[id]);
    },
    intersectingCustomTTS(state, getters) {
      const ret = {};
      if (state.useCustomTTS) {
        getters.customTTSList.forEach((item, i) => {
          if (i > 0) {
            const prev = getters.customTTSList[i - 1];
            if (item.start < prev.start + prev.duration) {
              ret[item.id] = true;
              return;
            }
          }
          if (item.start + item.duration > getters.totalDuration) {
            ret[item.id] = true;
          }
        });
      }
      return ret;
    },
    stampPadding,
    selectionLookup(state) {
      const ret = {};
      const selectedEffectIds = state.selectedEffectIds;
      // keep single selection as-is
      if (selectedEffectIds[0] === 'BACKGROUND_SELECT') {
        return {};
      }
      selectedEffectIds.forEach(id => {
        ret[id] = true;
      });
      return ret;
    },
    allVideos(state) {
      const { effects, fragments } = state;
      const getEffects = id => {
        const ef = effects[id];
        return ef ? [ef].concat(ef.children ? ef.children.map(getEffects) : []) : [];
      };
      const allEffects = _.flattenDeep(fragments.map(frag => frag.effects.map(getEffects)));
      console.log(allEffects);
      return allEffects.filter(ef => ef.type === 'video');
    },
    ...getters
  },
  modules
});
